var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.51794 13.007C6.66096 13.0074 6.80087 12.9653 6.91993 12.8861C7.03899 12.8068 7.13183 12.694 7.18668 12.5619C7.24152 12.4298 7.25591 12.2844 7.228 12.1441C7.2001 12.0039 7.13116 11.8751 7.02994 11.774L1.74794 6.50701L7.02994 1.23701C7.15626 1.09942 7.22452 0.918321 7.22044 0.731574C7.21637 0.544828 7.14027 0.366883 7.00806 0.234931C6.87585 0.102979 6.69776 0.0272314 6.511 0.0235196C6.32425 0.0198077 6.14329 0.0884189 6.00594 0.215013L0.211938 5.99701C0.144754 6.06407 0.0914529 6.14373 0.055086 6.23141C0.0187191 6.31909 0 6.41309 0 6.50801C0 6.60294 0.0187191 6.69693 0.055086 6.78462C0.0914529 6.8723 0.144754 6.95195 0.211938 7.01901L6.00594 12.801C6.07354 12.8673 6.15356 12.9197 6.24142 12.955C6.32927 12.9904 6.42324 13.008 6.51794 13.007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.1688c7738a8eb742abea1cf122688e8c.svg";
export { ForwardRef as ReactComponent };